module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-barrel-3.be4bc987.png";